import React from 'react';
import axios from 'axios';
import SearchAdd from 'src/ui/library/SearchAdd';
import Spinner from 'src/ui/library/Spinner/Spinner';
import intl from 'react-intl-universal';
import { SEARCH_ADD_PROPS } from 'src/constants/constants';
import { withSnackbar } from 'notistack';
import WithHeader from '../../wrappers/WithHeader';
import {
  fnSetEmployeeLookup,
  fnIsEmployeePresent,
  fnIsEmployeePresentAvailable,
  fnGetEmployeeLookup,
  fnSetEmployeForm,
  fnIsEmployeeFormPresent,
  fnGetEmployeeForm,
} from 'src/helpers/commonFunctions';

const CancelToken = axios.CancelToken;
class SearchAddControl extends React.Component {
  additionalProps = SEARCH_ADD_PROPS[this.props.entityName][this.props.attributeName];
  state = {
    value: this.props.value || '',
    formData: null,
    defaultValue: null /* this is an object used to populate <AutoComplete /> */,
    isLoading: false,
    fetchLookupValues: this.additionalProps.fetchLookupValues,
    getFormData: this.additionalProps.getFormData,
    saveFormData: this.additionalProps.saveFormData,
    searchColumn: this.additionalProps.searchColumn,
    styleType: this.additionalProps.styleType,
  };

  constructor(props) {
    super(props);
    this.cancelTokenFn = null;
  }

  componentDidMount() {
    this.getFormData();
    this.getDefaultValue();
  }

  componentWillUnmount() {
    if (this.cancelTokenFn !== null) {
      this.cancelTokenFn();
    }
  }

  getFormData = () => {
    if (this.props.entityName !== 'ey_contactemploymenthistory') {
      this.setState({ isLoading: true });
    }
    if (fnIsEmployeeFormPresent()) {
      const employeeForm = fnGetEmployeeForm();
      this.setState({ formData: { ...employeeForm }, isLoading: false });
    } else {
      this.state.getFormData().then(response => {
        if (response && !response.error && !response.errors) {
          this.setState({ formData: response, isLoading: false });
          if (this.props.entityName === 'ey_contactemploymenthistory') {
            fnSetEmployeForm(response);
          }
        } else {
          this.setState({ isLoading: false }, () => {
            return this.props.enqueueSnackbar('Failed to get form data', { variant: 'error' });
          });
        }
      });
    }
  };

  getDefaultValue = () => {
    if (this.props.value) {
      if (fnIsEmployeePresentAvailable()) {
        const defaultId = this.props.value.split('|')[0];
        const rowsObj = fnGetEmployeeLookup();
        const defaultValue = rowsObj.find(row => row.id === defaultId);
        this.setState({ defaultValue });
        return;
      }
      this.state
        .fetchLookupValues({
          filter: true,
          sortColumn: this.state.searchColumn,
          sortDirection: 'asc',
          pageSize: 100,
          pageNumber: 1,
          entityId: this.props.value.split('|')[0],
        })
        .then(response => {
          if (response && response.rows) {
            const defaultId = this.props.value.split('|')[0];
            const defaultValue = response.rows.find(row => row.id === defaultId);
            this.setState({
              defaultValue,
            });
          }
        });
    }
  };

  handleOnSearch = searchText => {
    if (this.cancelTokenFn !== null) {
      this.cancelTokenFn();
    }
    if (fnIsEmployeePresent(searchText)) {
      return new Promise((resolve, reject) => {
        resolve(fnGetEmployeeLookup());
      });
    }
    return this.state
      .fetchLookupValues(
        {
          searchText,
          filter: true,
          sortColumn: this.state.searchColumn,
          sortDirection: 'asc',
          pageSize: 100,
          pageNumber: 1,
        },
        { cancelToken: new CancelToken(c => (this.cancelTokenFn = c)) },
      )
      .then(response => {
        if (response && response.rows) {
          const data = response.rows.map((row, index) => ({ ...row, index }));
          if (this.props.entityName === 'ey_contactemploymenthistory') {
            fnSetEmployeeLookup(data);
          }
          return data;
        }
      });
  };

  handleOnChange = value => {
    let newValue = value && value.id;
    this.props.onChange({ target: { value: newValue } });
  };

  handleSaveSuccess = response => {
    this.setState({ defaultValue: response }, () => {
      this.handleOnChange(response);
    });
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="searchadd-wrapper">
          <Spinner size={30} />
        </div>
      );
    }
    const label =
      this.props.entityName === 'ey_serviceinitiation'
        ? intl.get('searchAdd.labels.serviceinitiationAdd')
        : intl.get('searchAdd.labels.add');
    return (
      <div className="searchadd-wrapper">
        <SearchAdd
          key={JSON.stringify(this.state.defaultValue)}
          styleType={this.state.styleType}
          addLabel={label}
          searchLabel={intl.get('searchAdd.labels.search')}
          defaultValue={this.state.defaultValue}
          formElements={this.state.formData}
          onChange={this.handleOnChange}
          onSaveForm={this.state.saveFormData}
          onSaveSuccess={this.handleSaveSuccess}
          onFilter={(row, val) => {
            if (row.data.displayText && row.data.displayText.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
              return true;
            }
            if (row.data.email && row.data.email.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
              return true;
            }
            return false;
          }}
          onSearch={this.handleOnSearch}
          onModifySaveRequest={payload => ({ ...payload, entityId: this.props.siEntityId })}
          getOptionValue={row => row}
          required={this.props.required}
          attributeName={this.props.attributeName}
        />
      </div>
    );
  }
}

export default WithHeader(withSnackbar(SearchAddControl));
